import { StyleSheet } from "aphrodite/no-important";
//import { colour, font } from '../style/base-theme';

export const styles = StyleSheet.create({
  logoWrapper: {
    flex: 1
  },
  logo: {
    display: "block",
    margin: "30px auto",
    padding: 0,
    height: 40
  },
  logoLarge: {
    padding: "35px 0"
  }
});
